;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="50162cfc-c1c6-48b5-b185-6590544816e0",e._sentryDebugIdIdentifier="sentry-dbid-50162cfc-c1c6-48b5-b185-6590544816e0")}catch(e){}}();
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(50680);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 50680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_base_button_SappButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98971);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15183);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12691);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43743);
/* harmony import */ var src_redux_hook__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34705);
/* harmony import */ var src_redux_slice_User_User__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85195);







var ErrorPage = function() {
    var userSlice = (0,src_redux_hook__WEBPACK_IMPORTED_MODULE_5__/* .useAppSelector */ .C)(src_redux_slice_User_User__WEBPACK_IMPORTED_MODULE_6__/* .userReducer */ .M3);
    var getRedirectPath = function() {
        if (userSlice.user.type === "STUDENT") {
            return src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.COURSES */ .H_.COURSES;
        }
        if (userSlice.user.type === "TEACHER") {
            return src_constants__WEBPACK_IMPORTED_MODULE_4__/* .PageLink.TEACHERS */ .H_.TEACHERS;
        }
        return "/";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex h-screen flex-col flex-nowrap items-center justify-center overflow-y-auto p-4 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: "h-max",
                src: "/assets/images/image_404.jpg",
                loading: "lazy",
                alt: "Image_404",
                width: "320",
                height: "260"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                className: "mt-10 text-2xl font-bold text-bw-1 md:text-4xl",
                children: "PAGE NOT FOUND"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mt-3 max-w-dl px-4 text-base text-gray-1",
                children: "We are very sorry for the inconvenience. It looks like you're trying to access a page that has been deleted or never even existed."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: getRedirectPath(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_SappButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        title: "Back to Home",
                        full: false,
                        className: "px-8 md:px-22",
                        size: "lager",
                        type: "submit"
                    })
                })
            })
        ]
    });
};
// eslint-disable-next-line import/no-unused-modules
/* harmony default export */ __webpack_exports__["default"] = (ErrorPage);
ErrorPage.layout = _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .LAYOUT.ERROR_LAYOUT */ ._.ERROR_LAYOUT;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);